export enum UserTypeEnum {
  USER = "user",
  COMPANY = "company",
  PROVIDER = "provider",
}
